import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import ProfileConfig from "@serie3/freelancesplaceapi/Config/Profiles/ProfileConfig";
import JobCard from "./JobCard";
import PublicJobView from "./PublicJobView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

const Jobs = ({ updateJobs, profileId }) => {
  const [viewJob, setViewJob] = useState();
  const [showView, setShowView] = useState(false);
  const [jobs, setJobs] = useState();

  useEffect(() => {
    const loadData = async () => {
      const jobData = await crudApi.show(ProfileConfig.endpoints.matchingJobs, profileId);
      if (jobData !== null && typeof jobData.hits?.hits !== "undefined") {
        setJobs(jobData.hits.hits);
      } else {
        setJobs([]);
      }
    };
    loadData();
  }, [updateJobs]);

  const showJobDetails = (job) => {
    setViewJob(job);
    setShowView(true);
  };

  if (!(profileId > 0 && jobs)) return null;

  return (
    <>
      {viewJob && (
        <PublicJobView jobId={viewJob._source.id} showView={showView} setShowView={setShowView} />
      )}
      <div style={{
        background: "#fff", borderRadius: "16px",
        boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
        overflow: "hidden", marginTop: "16px",
      }}>
        <div style={{
          padding: "14px 18px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex", alignItems: "center", gap: "8px",
        }}>
          <FontAwesomeIcon icon={faBriefcase} style={{ color: "#1a73e8", fontSize: "0.85rem" }} />
          <span style={{ fontWeight: 700, fontSize: "0.82rem", color: "#424242", textTransform: "uppercase", letterSpacing: "0.05em" }}>
            Matching Jobs
          </span>
          {jobs.length > 0 && (
            <span style={{
              marginLeft: "auto", fontSize: "0.72rem", fontWeight: 700,
              background: "#e8f0fe", color: "#1a73e8",
              padding: "2px 8px", borderRadius: "99px",
            }}>
              {jobs.length}
            </span>
          )}
        </div>
        <div style={{ padding: "10px 10px" }}>
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <JobCard key={job._source.id} job={job} showJobDetails={showJobDetails} />
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "24px 12px", color: "#bdbdbd", fontSize: "0.85rem" }}>
              No matching jobs found
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Jobs;
